import { T } from "../../common/drupal/drupal";

class Product {
	constructor() {
	}
	
	init(context) {
		const product = context.querySelector(".NodeProduct, .ProductList-item");
		if(product) {
			product.style.setProperty('--product-custom-bg', product.dataset.bgColor);
			product.style.setProperty('--product-custom-textColor', product.dataset.color);
			product.style.setProperty('--product-custom-bg--rgb', this.hexToRgb(product.dataset.bgColor.substring(1)));
			product.style.setProperty('--product-custom-textColor--rgb', this.hexToRgb(product.dataset.color.substring(1)));
		}
		const productItems = context.querySelectorAll(".ProductList-item");
		if(productItems.length > 0) {
			productItems.forEach(productItem => {
				productItem.style.setProperty('--product-custom-bg', productItem.dataset.bgColor);
				productItem.style.setProperty('--product-custom-textColor', productItem.dataset.color);
				productItem.style.setProperty('--product-custom-bg--rgb', this.hexToRgb(productItem.dataset.bgColor.substring(1)));
				productItem.style.setProperty('--product-custom-textColor--rgb', this.hexToRgb(productItem.dataset.color.substring(1)));
			});
		}
	}
	
	hexToRgb(hex) {
		var bigint = parseInt(hex, 16);
		var r = (bigint >> 16) & 255;
		var g = (bigint >> 8) & 255;
		var b = bigint & 255;
		
		return r + "," + g + "," + b;
	}
	
	attach(context, settings) {
		if(T.contextIsRoot(context)) {
			this.init(context);
		}
	}
}

export let product = new Product();